export default "__VITE_ASSET__C$wsFccl__"